import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=e30d986c&"
import script from "./loginForm.vue?vue&type=script&lang=js&"
export * from "./loginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports